module.exports = __webpack_public_path__ + "img/MICHEL_JONASZ_BEST_OF_15s.4af659c7.jpg";